import { pencesToPounds } from './pencesToPounds';
import {
  AUCTION_BID_MINIMUM_AMOUNT_IN_PENCE,
  AUCTION_MINIMUM_START_BID_AMOUNT_IN_PENCE,
} from '../../constants/AuctionBid';

export const getPlatformMinimumStartInPence = () =>
  AUCTION_MINIMUM_START_BID_AMOUNT_IN_PENCE + AUCTION_BID_MINIMUM_AMOUNT_IN_PENCE; // £150

export const getBaseBidInPence = (auction = {}, bidContext = {}, userMaxBidInPence = 0) => {
  if (bidContext?.state === 'highest_proxy' && Number(userMaxBidInPence) > 0) {
    return userMaxBidInPence;
  }
  if (Number(auction?.proxyBidInPence) > 0) return auction.proxyBidInPence;
  if (Number(auction?.highestBidInPence) > 0) return auction.highestBidInPence;
  return getPlatformMinimumStartInPence();
};

export const validateBidAmount = (value, auction, highestBidMyOrganization, stateCallback) => {
  const isCurrentBidderWinning = auction.bids.some((it) => it.isHighest);
  let requiredBidAmount;

  if (isCurrentBidderWinning) {
    requiredBidAmount = pencesToPounds(
      auction.highestBidInPence + AUCTION_BID_MINIMUM_AMOUNT_IN_PENCE,
    );
    if (value < requiredBidAmount) {
      stateCallback(requiredBidAmount);
      return false;
    }
  } else {
    if (auction.proxyBidInPence && auction.highestBidInPence) {
      requiredBidAmount = pencesToPounds(
        auction.proxyBidInPence + AUCTION_BID_MINIMUM_AMOUNT_IN_PENCE,
      );
    } else if (auction.highestBidInPence) {
      requiredBidAmount = pencesToPounds(
        auction.highestBidInPence + AUCTION_BID_MINIMUM_AMOUNT_IN_PENCE,
      );
    } else if (auction.minimumPriceInPence != null) {
      const platformMinStartInPence = getPlatformMinimumStartInPence();
      const effectiveMin = Math.max(auction.minimumPriceInPence, platformMinStartInPence);
      requiredBidAmount = pencesToPounds(effectiveMin);
    } else {
      const platformMinStartInPence = getPlatformMinimumStartInPence();
      requiredBidAmount = pencesToPounds(platformMinStartInPence);
    }

    if (value < requiredBidAmount) {
      stateCallback(requiredBidAmount);
      return false;
    }
  }
  return true;
};
